import React, { FC, useContext } from 'react';

import {
  Button,
  H3,
  Input,
  ISelectOption,
  NumberInput,
  Select,
} from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';
import { EPromoValueType } from 'types';
import { getRandomNumber } from 'utils';

import s from './FormComponents.module.scss';
import { IFormComponentsProps } from './interfaces';
import {
  generatePromoCodeName,
  getValuePresentIcon,
  getValuePresentTitle,
} from './utils';

export const MainInfo: FC<IFormComponentsProps> = ({
  control,
  setValue,
  watch,
  usedCodes,
  totalCodes,
  clearErrors,
}) => {
  const { t } = useContext(LocalizationContext);
  const { id } = useParams();
  const {
    state: {
      settings: { isBonusSystemEnabled, currency },
    },
  } = useContext(SettingsContext);
  const typePresentOptions: Array<ISelectOption> = [
    { title: t('discount'), value: EPromoValueType.DISCOUNT },
    { title: t('promo.present.type'), value: EPromoValueType.DEPOSIT },
    {
      title: t('promo.type.present.bonus'),
      value: EPromoValueType.BONUS,
      disabled: !isBonusSystemEnabled,
    },
  ];

  const rewardType = watch('rewardType');

  return (
    <div className={s.frame}>
      <div className={s.header}>
        <div className={s.left}>
          <H3>{t('promo.main.info')}</H3>
        </div>
        {id && (
          <div className={s.right}>
            {t('promo.main.info.use', String(usedCodes), String(totalCodes))}
          </div>
        )}
      </div>

      <div className={s.flex}>
        <Controller
          render={({ field: { name, ...field }, fieldState: { error } }) => (
            <Input
              {...field}
              title={t('promoCode')}
              name={`${name}-${getRandomNumber()}`}
              error={error?.message}
              placeholder="PROMO50"
              bordered
              className={s.promo_input}
              rightContent={
                <Button
                  className={s.generate_button}
                  variant="secondary"
                  onlyIcon
                  iconName="RandomIcon"
                  onClick={() => {
                    const promoCode = generatePromoCodeName();
                    setValue('code', promoCode, { shouldDirty: true });
                    clearErrors && clearErrors('code');
                  }}
                />
              }
            />
          )}
          name="code"
          control={control}
          rules={{
            required: t('errors.required'),
            minLength: {
              value: 4,
              message: t('errors.minLength', 4),
            },
            maxLength: {
              value: 12,
              message: t('errors.maxLength', 12),
            },
          }}
        />
      </div>

      {/*<Controller*/}
      {/*  render={({ field: { name, ...field }, fieldState: { error } }) => (*/}
      {/*    <Input*/}
      {/*      {...field}*/}
      {/*      title={t('title')}*/}
      {/*      name="name"*/}
      {/*      error={error?.message}*/}
      {/*      bordered*/}
      {/*      className={s.promo_input}*/}
      {/*      maxLength={24}*/}
      {/*    />*/}
      {/*  )}*/}
      {/*  name="title"*/}
      {/*  control={control}*/}
      {/*  rules={{*/}
      {/*    required: t('errors.required'),*/}
      {/*    minLength: {*/}
      {/*      value: 5,*/}
      {/*      message: t('errors.minLength', 5),*/}
      {/*    },*/}
      {/*    maxLength: {*/}
      {/*      value: 24,*/}
      {/*      message: t('errors.maxLength', 24),*/}
      {/*    },*/}
      {/*  }}*/}
      {/*/>*/}

      <div className={s.flex}>
        <Controller
          render={({ field: { name, ...field }, fieldState: { error } }) => (
            <Select
              name={'type'}
              options={typePresentOptions}
              {...field}
              placeholder={t('promo.type.present')}
              error={error?.message}
              bordered
              disableClear
            />
          )}
          name="rewardType"
          control={control}
          rules={{
            required: t('errors.required'),
          }}
        />
        <Controller
          render={({ field: { name, ...field }, fieldState: { error } }) => (
            <NumberInput
              {...field}
              title={getValuePresentTitle(t, rewardType)}
              error={error?.message}
              bordered
              disabled={!rewardType}
              rightContent={getValuePresentIcon(rewardType, currency)}
            />
          )}
          name="rewardValue"
          control={control}
          rules={{
            required: t('errors.required'),
            max:
              rewardType === EPromoValueType.DISCOUNT
                ? {
                    value: 100,
                    message: t('errors.max', 100, '%'),
                  }
                : undefined,
          }}
        />
      </div>
    </div>
  );
};
